/* ============================================================
   Carbon Offset Upsell — Jules Taylor Wines — Dawn Theme
   ============================================================ */

(function () {
  const CARBON_PRODUCT_ID = 8633625936022;

  // Fetch the variant ID from the product JSON (handles any variant setup)
  async function getCarbonVariantId() {
    try {
      // Try to get from a data attribute first (set by Liquid if product exists)
      const wrap = document.querySelector('[data-carbon-product-id]');
      if (wrap && wrap.dataset.carbonVariantId) {
        return parseInt(wrap.dataset.carbonVariantId);
      }
      // Otherwise fetch from product JSON
      const res = await fetch('/products/carbon-offset.js');
      if (!res.ok) throw new Error('Product not found');
      const data = await res.json();
      return data.variants[0].id;
    } catch (e) {
      console.error('Carbon offset: could not get variant ID', e);
      return null;
    }
  }

  async function getCartItems() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    return cart.items;
  }

  async function addToCart(variantId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (!res.ok) throw new Error('Failed to add carbon offset');
    return res.json();
  }

  async function removeFromCart(variantId) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 0 })
    });
    if (!res.ok) throw new Error('Failed to remove carbon offset');
    return res.json();
  }

  function setLoading(wrap, state) {
    const loader = wrap.querySelector('.carbon-offset__loading');
    if (!loader) return;
    loader.style.display = state ? 'flex' : 'none';
    wrap.classList.toggle('carbon-offset--loading', state);
  }

  // After cart changes, trigger Dawn's native cart refresh
  function refreshCart() {
    // Dawn uses a custom event to re-render the cart drawer and cart page totals
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );
    // Also dispatch the standard Dawn cart update event
    document.documentElement.dispatchEvent(
      new CustomEvent('cart-update', { bubbles: true })
    );
    // Force reload cart-notification and cart drawer via fetch if available
    if (typeof window.Shopify !== 'undefined') {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:updated', { bubbles: true, detail: { cart } })
          );
        });
    }
    // On the cart page, reload to reflect updated totals
    if (window.location.pathname === '/cart') {
      window.location.reload();
    }
  }

  async function handleChange(checkbox, wrap) {
    setLoading(wrap, true);
    try {
      const variantId = await getCarbonVariantId();
      if (!variantId) throw new Error('No variant ID');

      if (checkbox.checked) {
        await addToCart(variantId);
      } else {
        // Find the line item key for this variant to remove it
        const items = await getCartItems();
        const carbonItem = items.find(i => i.product_id === CARBON_PRODUCT_ID);
        if (carbonItem) {
          await removeFromCart(carbonItem.variant_id);
        }
      }
      refreshCart();
    } catch (e) {
      console.error('Carbon offset error:', e);
      // Revert checkbox state on error
      checkbox.checked = !checkbox.checked;
    } finally {
      setLoading(wrap, false);
    }
  }

  function init() {
    // Use event delegation to handle both cart drawer and cart page instances
    document.addEventListener('change', function (e) {
      if (!e.target.matches('.carbon-offset__input')) return;
      const wrap = e.target.closest('.carbon-offset-wrap');
      if (!wrap) return;
      handleChange(e.target, wrap);
    });

    // Keep checkboxes in sync if Dawn re-renders the cart drawer
    document.addEventListener('cart:updated', syncCheckboxes);
    document.addEventListener('cart-update', syncCheckboxes);
  }

  async function syncCheckboxes() {
    try {
      const items = await getCartItems();
      const inCart = items.some(i => i.product_id === CARBON_PRODUCT_ID);
      document.querySelectorAll('.carbon-offset__input').forEach(cb => {
        cb.checked = inCart;
      });
    } catch (e) {
      // fail silently
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
